(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('social-insurance', {
            parent: 'entity',
            url: '/social-insurance?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.socialInsurance.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/social-insurance/social-insurances.html',
                    controller: 'SocialInsuranceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('socialInsurance');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('social-insurance-detail', {
            parent: 'entity',
            url: '/social-insurance/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.socialInsurance.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/social-insurance/social-insurance-detail.html',
                    controller: 'SocialInsuranceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('socialInsurance');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SocialInsurance', function($stateParams, SocialInsurance) {
                    return SocialInsurance.get({id : $stateParams.id});
                }]
            }
        })
        .state('social-insurance.new', {
            parent: 'social-insurance',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-insurance/social-insurance-dialog.html',
                    controller: 'SocialInsuranceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('social-insurance', null, { reload: true });
                }, function() {
                    $state.go('social-insurance');
                });
            }]
        })
        .state('social-insurance.edit', {
            parent: 'social-insurance',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-insurance/social-insurance-dialog.html',
                    controller: 'SocialInsuranceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SocialInsurance', function(SocialInsurance) {
                            return SocialInsurance.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('social-insurance', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('social-insurance.delete', {
            parent: 'social-insurance',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-insurance/social-insurance-delete-dialog.html',
                    controller: 'SocialInsuranceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SocialInsurance', function(SocialInsurance) {
                            return SocialInsurance.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('social-insurance', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
